import React from "react";
import { Link } from "react-router-dom";
import Image5 from "../../../images/Image5.jpg";
import SplitStorySection from "../../ui/SplitStorySection";
import FadeIn from "../../ui/FadeIn";

const ASection1 = () => (
  <section className="ku-section bg-white">
    <div className="ku-container">
      <FadeIn>
        <h2 className="ku-heading-lg text-center max-w-4xl mx-auto mb-12">
          Does being kind leave you feeling tired, insecure or regretful?
        </h2>
      </FadeIn>
    </div>
    <SplitStorySection image={Image5} imageAlt="Kindness journey" className="!pt-0">
      <p>
        Imagine this, it&apos;s 6 O&apos;clock in the evening & you&apos;re all set to leave for home. On your way to the door, you exchange a goodbye with the teammate who&apos;s working overtime, when suddenly, he stops you to ask for quick help.
      </p>
      <p>
        You&apos;re tired, your children are expecting you to get back home early & tomorrow&apos;s gonna be an equally busy workday for you. But, you don&apos;t want to come across as a selfish teammate, so you accept his request.
      </p>
      <p>
        10 minutes into it, and this colleague gets a call to reach home ASAP. Unexpected guests seem to have arrived at his place! Helpless, he requests you to cover for him. <br />
        What do you do next?
      </p>
      <p>
        You get overwhelmed with the borrowed workload, resentment for your teammate crops in & you realise that perhaps kindness is for fools!
      </p>
      <h3 className="font-display text-2xl font-bold text-ku-royal mt-6">That&apos;s where we come in!</h3>
      <p>
        Kindness Unlimited helps you spread kindness by giving you a practical approach to being kind without having to feel overwhelmed.
      </p>
      <Link to="/contactus" className="ku-btn-primary inline-flex mt-4">
        I&apos;d like to start my kindness journey
      </Link>
    </SplitStorySection>
  </section>
);

export default ASection1;
